module.exports = __webpack_public_path__ + "static/media/film-production-grid-3.e7e902ba.jpg";